import React, { useState, useEffect, useRef } from 'react';
import { Table, TableBody, TableCell, IconButton, Box, TableContainer, TablePagination, TableFooter, TableHead, TableRow, TableSortLabel, Checkbox } from '@mui/material';
import clsx from "clsx";
import customSortIcon from "../Icons/sortIcon";
import sortIconUp from "../Icons/sortIconUp";
import customStyles from "../../../../assets/styles/customStyles";
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

function TablePaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
    const classes = customStyles();
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box className={classes.tablePagnationRow} sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                <FirstPageIcon />
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            ><LastPageIcon />
            </IconButton>
        </Box>
    );
}

export default function PaginationTable(props) {
    const { heads, component, sortOrder, sortBy, rows,
        onRequestSort, page, rowsPerPage, changePage, clearOption,
        changeRowsPerPage, onSelected, details = [], selected = [], width } = props;
    const classes = customStyles();
    const tableEl = useRef();
    const [tpage, setTpage] = useState(0);
    const [trowsPerPage, setTrowsPerPage] = useState(rowsPerPage);


    const handleChangePage = (event, newPage) => {
        setTpage(newPage);
        changePage(event, newPage);
    };

    useEffect(() => {
        setTpage(page);
    }, [page]);

    const handleChangeRowsPerPage = (event) => {
        setTrowsPerPage(parseInt(event.target.value, 10));
        changeRowsPerPage(event);
    };

    const onSelectAllClick = (e) => {
        if (e.target.checked) {
            const newSelecteds = details && details.map((n) => n.id);
            onSelected(newSelecteds);
            return;
        }
        onSelected([]);
    }

    return (
        <TableContainer ref={tableEl} className={clsx(classes.tablecontain, { [classes.margin30t]: clearOption }, classes.paginationTablecontain)}>
            {
                clearOption ? clearOption : ''
            }
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {heads.map((head, i) => {
                            return (
                                <TableCell style={{ width: width ? '' : head.name === 'Actions' ? '40%' : '13%' }} key={i} className={clsx(head.key, classes.tablealign, { [classes.sortColParent]: head.sorting }, { [classes.amountRightAlign]: head.amount }, { [classes.textAlignRight]: head.rightAlign })}>
                                    {
                                        head.sorting ? <TableSortLabel
                                            className={classes.sortCol}
                                            IconComponent={sortOrder === 'desc' && sortBy === head.key ? sortIconUp : customSortIcon}
                                            direction={sortOrder}
                                            onClick={() => onRequestSort(head.key, sortOrder === 'asc' ? 'desc' : 'asc')}
                                        >{head.name}</TableSortLabel> : head.key === 'checkbox' ?
                                            <Checkbox
                                                color="primary"
                                                indeterminate={selected?.length > 0 && selected?.length < details.length}
                                                checked={details?.length > 0 && selected?.length === details?.length}
                                                onChange={(e) => onSelectAllClick(e)}
                                                inputProps={{
                                                    'aria-label': 'select all desserts',
                                                }}
                                            /> : head.actionWidth ? <span style={{ width: head.actionWidth }} className={classes.actionColumn}>{head.name}</span> : head.name
                                    }
                                </TableCell>
                            )
                        })}
                    </TableRow>
                </TableHead>
                <TableBody className={classes.paginationTableRow}>
                    {component}
                </TableBody>
                {
                    rows.length > 500 && <TableFooter>
                        <TableRow>
                            <TablePagination
                                classes={classes.tablePagnationRow}
                                rowsPerPageOptions={[-1]}
                                colSpan={heads.length}
                                count={rows.length}
                                rowsPerPage={trowsPerPage}
                                page={tpage}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            //labelDisplayedRows={() => { return true; }}
                            />
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </TableContainer>
    );
}
